<template>
  <custom-dialog
    :width="dialogWidth"
    :title="title"
    class="check-relative-model-dialog"
    :visible="visible"
    v-on="$listeners"
    :append-to-body="true"
    top="5vh"
  >
    <div
      class="dialog-body"
      style="padding-top: 0"
    >
      <!-- Topic关联的物模型 -->
      <relative-model
        :topicId="model.data.topicId"
        :protocolCode="protocolCode"
        :tableHeight="tableHeight"
      ></relative-model>
    </div>
  </custom-dialog>
</template>

<script>
import dialogMixins from '@/mixins/dialog_mixins';
import relativeModel from './topic_detail_relative_model.vue';

export default {
  name: 'checkRelativeModelDialog',
  mixins: [dialogMixins],
  components: {
    relativeModel,
  },
  props: {
    protocolCode: String,
  },
  data() {
    return {};
  },
  computed: {
    title() {
      return `${this.model.title} - ${this.model.data.topicCode}`;
    },
    dialogWidth() {
      const width = window.innerWidth * 0.9;
      return [width, 'px'].join('');
    },
    tableHeight() {
      // dialog中，除了table以外的div的总高度
      const defaultHeight = 209;
      const dialogHeight = window.innerHeight * 0.9;
      const tableHeight = Math.max(dialogHeight - defaultHeight, 400);
      return [tableHeight, 'px'].join('');
    }
  },
  watch: {},
  filters: {},
  directives: {},
  methods: {},
  created() { },
  mounted() { },
};
</script>

<style lang="scss">
.check-relative-model-dialog {
  .protocol-topic-detail-relative-model {
    padding-top: 0;
  }
}
</style>
